import type { ThemeColor } from '~/theme/System/tokens/colorPalette';
import type { CardStatus } from './utils/getFrontendStatus';
import { Lfa_Service_Acceptance_Status } from '~/graphql/types';

export const MAX_HEIGHT = '1000px';

export const cardStatusLabelsMap = (
  status: CardStatus,
  daysToAutoAccept: number,
  isSnoozed: boolean,
) =>
  ({
    prepareForAppointment: 'Voorbereiden op afspraak',
    waitingForFeedback: isSnoozed
      ? 'Geef opnieuw de status door'
      : 'Heeft de afspraak plaatsgevonden? Geef de status door',
    expiring:
      daysToAutoAccept > 0
        ? `Nog ${daysToAutoAccept} dagen om status te updaten`
        : 'Vandaag is de laatste dag om de status bij te werken',
    completed: 'Geaccepteerd',
    rejected: 'Afgewezen',
  })[status];

export const statusColorMap: {
  [key in CardStatus]: { text: ThemeColor; background: ThemeColor };
} = {
  prepareForAppointment: {
    text: {
      group: 'success',
      variant: 'base',
    },
    background: {
      group: 'success',
      variant: 'translucent',
    },
  },
  waitingForFeedback: {
    text: {
      group: 'warning',
      variant: 'dark',
    },
    background: {
      group: 'warning',
      variant: 'translucent',
    },
  },
  expiring: {
    text: {
      group: 'danger',
      variant: 'dark',
    },
    background: {
      group: 'danger',
      variant: 'translucent',
    },
  },
  completed: {
    text: {
      group: 'info',
      variant: 'dark',
    },
    background: {
      group: 'info',
      variant: 'translucent',
    },
  },
  rejected: {
    text: {
      group: 'info',
      variant: 'dark',
    },
    background: {
      group: 'info',
      variant: 'translucent',
    },
  },
};

type AnswerOption = { label: string; type: Lfa_Service_Acceptance_Status };
export const appointmentAnswerOptions: Array<AnswerOption> = [
  { label: 'Ja', type: Lfa_Service_Acceptance_Status.Accepted },
  { label: 'Nee', type: Lfa_Service_Acceptance_Status.Rejected },
];

export const conversionAnswerOptions: Array<AnswerOption> = [
  { label: 'Ja', type: Lfa_Service_Acceptance_Status.Accepted },
  { label: 'Nee', type: Lfa_Service_Acceptance_Status.Rejected },
  {
    label: 'Ik ben nog in gesprek (uitstellen tot 3 maanden)',
    type: Lfa_Service_Acceptance_Status.Snoozed,
  },
];
